import { useCallback } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { selectEnvironment, selectSelectedView, selectUser } from "../../store/selector";
import { trackPendoEvent } from "./pendoUtils";

export const useDashboardBucketsTrackingEvent = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const account = useSelector(selectEnvironment);
  const selectedView = useSelector(selectSelectedView);

  const trackEvent = (eventName, extraData = {}) => {
    try {
      trackPendoEvent(dispatch, eventName, {
        user: user?.email,
        account,
        selectedView,
        ...extraData
      });
    } catch (errorText) {
      console.error("Error dispatching dashboard filters Pendo event:", errorText);
    }
  };
  return { trackEvent };
};

export const useDashboardBucketsTrackingEventStable = () => {
  const dispatch = useDispatch();
  const store = useStore();

  const trackEvent = useCallback(
    (eventName, extraData = {}) => {
      try {
        const state = store.getState();
        const user = selectUser(state);
        const account = selectEnvironment(state);
        const selectedView = selectSelectedView(state);

        trackPendoEvent(dispatch, eventName, {
          user: user?.email,
          account,
          selectedView,
          ...extraData
        });
      } catch (errorText) {
        console.error("Error dispatching dashboard filters Pendo event:", errorText);
      }
    },
    [dispatch, store]
  );

  return { trackEvent };
};
